import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}, c = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  d: "m6.379 11.556-.562.497a.75.75 0 0 0 1.08.044zm2.14-1.015a.75.75 0 0 0-1.037-1.082zM5.563 9.503a.75.75 0 1 0-1.122.994zm8.37-1.494a.75.75 0 0 0 1.102-1.018l-1.101 1.018zM11.046 5.25c-2.986 0-5.416 2.403-5.416 5.38h1.5c0-2.137 1.747-3.88 3.916-3.88zM5.63 10.63v.926h1.5v-.926zm1.269 1.467 1.622-1.556-1.038-1.082-1.622 1.555zm.042-1.039L5.56 9.503l-1.121.994 1.377 1.556 1.124-.995Zm8.093-4.067a5.42 5.42 0 0 0-3.99-1.741v1.5a3.92 3.92 0 0 1 2.89 1.26zm.586 3.453.56-.498a.75.75 0 0 0-1.08-.043zm-2.14 1.014a.75.75 0 1 0 1.04 1.082zm2.96 1.04a.75.75 0 0 0 1.12-.997zm-8.392 1.507a.75.75 0 0 0-1.094 1.026zm2.888 2.745c2.993 0 5.434-2.4 5.434-5.38h-1.5c0 2.135-1.753 3.88-3.934 3.88zm5.434-5.38v-.926h-1.5v.926zM15.1 9.903l-1.62 1.555 1.04 1.082 1.619-1.555zm-.04 1.04 1.38 1.554 1.122-.996-1.382-1.555zM6.953 15.03a5.45 5.45 0 0 0 3.982 1.719v-1.5c-1.143 0-2.17-.48-2.888-1.245l-1.093 1.027z"
}, null, -1), l = /* @__PURE__ */ e("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10Z"
}, null, -1), n = [
  c,
  l
];
function a(m, s) {
  return t(), o("svg", r, [...n]);
}
const h = { render: a };
export {
  h as default,
  a as render
};
